export const CLASS_NAME = 'cst-dashboard-cards'
